import React from "react";

/**
 * TVFrame — wraps a horizontal 16:9 video to look like it's playing on a
 * modern TV (thin bezel, glow halo, small stand). Used for ads with
 * format: "tv-social".
 *
 * Props:
 *   - src      : video URL
 *   - poster   : poster image URL
 *   - testId   : data-testid for the video element
 */
const TVFrame = ({ src, poster, testId, aspectRatio = "16/9" }) => {
  return (
    <div className="relative mx-auto w-full" data-testid="tv-frame" style={{ maxWidth: 470 }}>
      {/* Subtle glow halo behind the TV */}
      <div
        aria-hidden="true"
        className="absolute -inset-3 rounded-2xl bg-[var(--af-lime)]/15 blur-2xl opacity-50 -z-10"
      />

      {/* TV body — ultra-thin silver bezel */}
      <div
        className="rounded-lg p-[1.5px] shadow-2xl"
        style={{
          aspectRatio,
          background:
            "linear-gradient(180deg, #d6d6d8 0%, #b4b4b8 50%, #8e8e93 100%)",
        }}
      >
        {/* Screen */}
        <div className="w-full h-full bg-black rounded-md overflow-hidden">
          <video
            src={src}
            poster={poster}
            controls
            playsInline
            preload="metadata"
            className="w-full h-full object-cover"
            data-testid={testId}
          />
        </div>
      </div>

      {/* TV stand */}
      <div className="mx-auto w-1/4 h-1 bg-neutral-400 rounded-b-md" />
      <div className="mx-auto w-1/6 h-0.5 bg-neutral-500 rounded-b-md" />
    </div>
  );
};

export default TVFrame;
export { TVFrame };
